module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"action":{"preview":"Preview"},"disabled":{"processing":"Preview has not finished processing for this Form. Please refresh later and try again.","notOpen":"In this version of ODK Central, preview is only available for Forms in the Open state."}}}')
  delete Component.options._Ctor
}
